import ImageOne from '../images/Image1.png'
import ImageTwo from '../images/Image2.png'
import ImageThree from '../images/Image3.png'
import ImageFour from '../images/Image4.png'
import ImageFive from '../images/Image5.png'
export const portfolioData = [
    {
      id: 2,
      name: "AR Furniture",
      image: ImageOne,
      link: "https://ar-furniture-chi.vercel.app/",
    },
    {
      id: 2,
      name: "Employee Admin App",
      link: "https://employees-admin.vercel.app/",
      image: ImageTwo,
    },
    {
      id: 2,
      name: "FagitAR",
      image: ImageThree,
      link: "https://fagitar.netlify.app/",
    },
    {
      id: 2,
      name: "Chat On",
      image: ImageFour,
  
      link: "https://zesty-sleet-order.glitch.me/",
    },
    {
      id: 3,
      name: "Repositary on CLI",
      image: ImageFive,
      link: "https://github.com/Ankurallin1/Repo-using-CLI",
    },
  ];
 export const filterData = [
    {
      filterId: 1,
      label: "All",
    },
    {
      filterId: 2,
      label: "Developement",
    },
    {
      filterId: 3,
      label: "Innovation",
    },
  ];